import api from '../../utils/api'

import { useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormClient from './Form/FormClient'

function NewClient({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    async function registerClient(client) {
        let msgType = 'success'

        const data = await api.post('/client/new', client, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <FormClient title="Cadastrar Cliente" handleSubmit={registerClient} btCancelAction={btCancelAction} btnText="Salvar" />
    )
}

export default NewClient
